function compareRandom() {
	return Math.random() - 0.5;
}

export function randomCards() {
	return new Promise((resolve) => {
		const list = document.querySelectorAll('.grid-item');

		Array.prototype.slice.call(list).sort(compareRandom).forEach((el) => {
			el.parentNode.removeChild(el);
			document.querySelector('.grid__row').appendChild(el);
		});

		resolve();
	});
}
